// addressSlice.js

import { createSlice } from '@reduxjs/toolkit';

const testaddressDataSlice = createSlice({
  name: 'testAddress',
  initialState: {
    defaultAddressData: null,
  },
  reducers: {
    setDefaultAddressData: (state, action) => {
      state.defaultAddressData = action.payload;
    },
  },
});

export const { setDefaultAddressData } = testaddressDataSlice.actions;
export default testaddressDataSlice.reducer;
